<template>
    <v-layout class="app-content sistema-template">
        <v-container class="justify d-flex" fluid style="flex-wrap:wrap;margin-top: 50px;justify-content:flex-start;position: relative; align-content:flex-start">
            <div class="d-inline-flex justify-space-between mt-0" style="width:100%;">
                <div class="texto_ambiente">Selecione a marca e a administradora desejada</div>
                <div class="info-text">
                    Usuario <strong>{{ login }} - {{ nome }}</strong
                    >; Unidade: <strong>{{ unidade_exclusiva.cd_unidade_negocio }} - {{ unidade_exclusiva.nm_unidade_negocio }}</strong>
                </div>
            </div>
            <v-container v-if="!verificaAmbientes(ambientesPermitidos) && carregou" class="justify d-flex" fluid style="flex-wrap:wrap;justify-content:center;position: absolute;top:calc(50% - 15px);">
                <span v-if="exibir_erro">Não identificamos ambientes disponíveis para o seu usuário, entre em contato com o time de suporte.</span>
            </v-container>
            <v-col v-else class="justify px-2 mb-4" v-for="ambiente in ambientesPermitidos" :key="ambiente.id" cols="6" md="4" lg="3">
                <template>
                    <v-card class="ambiente-card mx-auto py-2 px-4  mt-12" max-width="390">
                        <div class="d-flex align-center" style="flex-direction:column;">
                            <v-img
                              :class="['logo', 'mx-6', { 'logo-royal': ['royal_enf', 'royal_enfield', 'consorcio_pan'].includes(trazerNomeFlavor(ambiente.nm_flavor)) }]"
                              contain
                              :max-width="['royal_enf', 'royal_enfield', 'consorcio_pan'].includes(trazerNomeFlavor(ambiente.nm_flavor)) ? '85%' : '70%'"
                              max-height="100%"
                              height="100px"
                              width="100%"
                              style="margin:10px;background-size: contain;"
                              :src='"../assets/flavors/" + trazerNomeFlavor(ambiente.nm_flavor) + "/img/logo-menu.png"'
                            ></v-img>
                        </div>
                        <p class="no-wrap-text">Administradora {{ ambiente.nm_empresa_newcon }}</p>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn :id="'botao-selecionar-ambiente-' + ambiente.id" class="mr-2 mt-5 px-7" color="primary" @click="enviarParaAmbiente(ambiente)">
                                ATIVAR
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </template>
            </v-col>
        </v-container>
    </v-layout>
</template>

<script>
  import { flavorRes, loadFlavor } from '@/plugins/flavors'
  import { mapState } from 'vuex'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import { notification } from '@/plugins/helpers'
  import { AlertTypes } from '../plugins/alerts_types'
  export default {
    name: 'EscolhaAmbientes',
    data: () => ({
      persistir_sessao: false,
      logo: '',
      exibir_erro: false,
      carregou: false,
      ambientesPermitidos: [],
      caminhoImagemPadrao: '../assets/flavors/$1/img/logo-menu.png'
    }),
    computed: {
      ...mapState(['ids_empresas_permitidas', 'unidade_exclusiva', 'id_usuario', 'login', 'nome', 'vendas_backoffice'])
    },
    async mounted () {
      loadFlavor('rodobens')
      this.logo = flavorRes('img/logo-menu.png')
      await this.pegarLoginUsuario(this.id_usuario)
      await this.carregarAmbientes(this.ids_empresas_permitidas, this.unidade_exclusiva.cd_unidade_negocio)
    },
    beforeDestroy () {
      if (!this.persistir_sessao) {
        this.$session.destroy()
      }
    },
    methods: {
      async pegarLoginUsuario (id_pessoa_erp) {
        await this.$http.get(`/usuarios/${id_pessoa_erp}`).then(response => {
          this.$session.set('login', response.data.login)
        })
      },
      verificaAmbientes (data) {
        data = JSON.parse(JSON.stringify(data))
        let vetor = []
        for (let i in data) {
          vetor.push(data[i])
        }
        data = vetor
        if (data.length === 1) {
          this.enviarParaAmbiente(data[0])
          return true
        } else if (data.length === 0) {
          this.exibir_erro = true
          return false
        } else {
          return true
        }
      },
      enviarParaAmbiente (ambiente) {
        this.persistir_sessao = true
        sendAnalyticsEvent(this.$gtag, 'escolher_ambiente', { white_label_marca: ambiente.id_visual })

        const mapaCondicoes = this.$session.get('unidades_condicoes_venda') || {}
        const condicaoAmbiente = ambiente.unidade_condicoes_venda || null
        const condicaoUsuario = mapaCondicoes[ambiente.id_visual] || null

        const podeAtivar = condicaoAmbiente === null || condicaoAmbiente.toString() === condicaoUsuario?.toString()

        if (!podeAtivar) {
          notification(AlertTypes.ERROR, 'Caro parceiro, seu usuário não está liberado para esse ambiente, por favor, entre em contato com a Área de Suporte!')
          return
        }

        if (ambiente.url === 'localhost:8080') {
          window.open('http://' + ambiente.url + '/Sistema/#/setar_ambiente_ssov2?ambiente=' + btoa(JSON.stringify(ambiente)) + '&dados_usuario=' + btoa(JSON.stringify(this.pegarPayloadDeLogin())), '_self')
        } else {
          window.open('https://' + ambiente.url + '/Sistema/#/setar_ambiente_ssov2?ambiente=' + btoa(JSON.stringify(ambiente)) + '&dados_usuario=' + btoa(JSON.stringify(this.pegarPayloadDeLogin())), '_self')
        }
      },
      // Função criada pois o flavor Tribanco vem com o nome "Tribanco " e o nome do diretório é "tribanco"
      trazerNomeFlavor (nomeFlavor) {
        const flavorNormalizado = nomeFlavor.toLowerCase().trim().replace(/\s+/g, '')
        // Correção temporária: mapeia consortio_pan para consorcio_pan
        return flavorNormalizado === 'consortio_pan' ? 'consorcio_pan' : flavorNormalizado
      },
      async carregarAmbientes (ids_empresas, cd_unidade_exclusiva) {
        await this.$http
          .post('/ambientes', { ids_empresas, cd_unidade_exclusiva })
          .then(res => {
            const vistos = new Set()
            this.ambientesPermitidos = res.data.filter(a => {
              const chave = `${a.nm_flavor}|${a.id_empresa_newcon}`
              if (vistos.has(chave)) return false
              vistos.add(chave)
              return true
            })
            return res.data
          })
          .catch(err => {
            const statusCode = err?.response?.status

            if (statusCode === 403 || statusCode === 409) {
              notification(AlertTypes.ERROR, 'Seu usuário não possui permissão ativa para acessar este ambiente. Entre em contato com a Área de Suporte.')
            } else {
              notification(AlertTypes.ERROR, 'Não foi possível carregar os ambientes no momento. Tente novamente.')
            }

            this.ambientesPermitidos = []
            this.exibir_erro = true
          })
          .finally(() => {
            this.carregou = true
          })
      },
      pegarPayloadDeLogin () {
        const id_usuario = this.$session.get('id_usuario')
        const login = this.$session.get('login')
        const nome = this.$session.get('nome')
        const token = this.$session.get('token')
        const empresas = this.$session.get('empresas')
        const unidades = this.$session.get('unidades')
        const id_comissionado = this.$session.get('id_comissionado')
        const filiais = this.$session.get('filiais')
        const id_ponto_venda = this.$session.get('id_ponto_venda')
        const id_unidade_negocio = this.$session.get('id_unidade_negocio')
        const admin = this.$session.get('admin')
        const exibe_politica_vendas = this.$session.get('exibe_politica_vendas')
        const permite_cnpj_alfanumerico = this.$session.get('permite_cnpj_alfanumerico')
        const limite_cotas_para_reservar_ativo = this.$session.get('limite_cotas_para_reservar_ativo')
        const quantidade_cotas_reservar = this.$session.get('quantidade_cotas_reservar')
        const percentual_cotas_disponiveis_ativo = this.$session.get('percentual_cotas_disponiveis_ativo')
        const percentual_cotas_disponiveis = this.$session.get('percentual_cotas_disponiveis')
        const procura_cidade_por_id = this.$session.get('procura_cidade_por_id')
        const exibe_contratos_painel = this.$session.get('exibe_contratos_painel')
        const exibe_contratos_sistema = this.$session.get('exibe_contratos_sistema')
        const exibe_reenvio_whatsapp = this.$session.get('exibe_reenvio_whatsapp')
        const permite_logar_tela_login = this.$session.get('permite_logar_tela_login')
        const permite_multiplicar_cota = this.$session.get('permite_multiplicar_cota')
        const exibe_reenvio_email = this.$session.get('exibe_reenvio_email')
        const id_usuario_interno = this.$session.get('id_usuario_interno')
        const produtos = this.$session.get('produtos')
        const origemAcesso = this.$session.get('origem_acesso')
        const vendas_backoffice = this.vendas_backoffice
        const filial = this.$session.get('filial')
        const identificador_representante_tribanco = this.$session.get('identificador_representante_tribanco')
        const ids_empresas_permitidas = this.$session.get('ids_empresas_permitidas')
        const unidade_exclusiva = this.$session.get('unidade_exclusiva')
        const tempo_alertas_erro = this.$session.get('tempo_alertas_erro')
        const tempo_alertas_variados = this.$session.get('tempo_alertas_variados')
        const unidades_condicoes_venda = this.$session.get('unidades_condicoes_venda')
        const broker_fluxo_vendas_comum = this.$session.get('broker_fluxo_vendas_comum')
        const broker_politica_vendas = this.$session.get('broker_politica_vendas')
        return {
          id_usuario,
          login,
          nome,
          token,
          empresas,
          unidades,
          id_comissionado,
          filiais,
          id_ponto_venda,
          id_unidade_negocio,
          admin,
          exibe_politica_vendas,
          permite_cnpj_alfanumerico,
          limite_cotas_para_reservar_ativo,
          percentual_cotas_disponiveis_ativo,
          percentual_cotas_disponiveis,
          quantidade_cotas_reservar,
          procura_cidade_por_id,
          exibe_contratos_painel,
          exibe_contratos_sistema,
          exibe_reenvio_whatsapp,
          exibe_reenvio_email,
          permite_logar_tela_login,
          permite_multiplicar_cota,
          id_usuario_interno,
          produtos,
          vendas_backoffice,
          filial,
          identificador_representante_tribanco,
          ids_empresas_permitidas,
          unidade_exclusiva,
          origemAcesso,
          tempo_alertas_erro,
          tempo_alertas_variados,
          unidades_condicoes_venda,
          broker_fluxo_vendas_comum,
          broker_politica_vendas
        }
      }
    }
  }
</script>

<style scoped>
.logo {
    margin-top: 10px;
}

.logo-royal {
  height: 112px !important;
}
.no-wrap-text {
    word-break: keep-all;
    line-height: 20px;
    overflow: hidden;
    margin: 10px;
    text-align: center;
    color: #777;
    font-size: 16px;
    font-weight: bold;
    text-shadow: 0px 0px rgb(93, 93, 93);
    margin: 0;
    padding: 0;
}
.texto_ambiente {
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: var(--primary);
    margin-right: 10px;
}
.info-text {
    font-size: 14px;
    font-weight: 500;
    color: #777;
}

.business-text {
    font-size: 17px;
    font-weight: 500;
    color: #aaa;
}
.text_cod_empresa_e_id_visual {
    font-size: 17px;
    font-weight: bold;

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin-left: 10px;
    color: #777;
}

.ambiente-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
</style>
